export default [
    {
        path: '/arriendos',
        name: 'arriendos',
        meta: { authRequired: true },
        component: () => import('./Leases.vue')
    },
    {
        path: '/arriendos-lop',
        name: 'arriendosLop',
        meta: { authRequired: true },
        component: () => import('./Leases.vue')
    },
    {
        path: '/documentacion-contrato',
        name: 'documentacionContrato',
        meta: {authRequired: true},
        component: () => import('./Documents/DocumentacionContrato.vue')
    },
    {
        path: '/detalle-facturaLOP',
        name: 'detalleFacturaLOP',
        meta: {authRequired: true},
        component: () => import('./Documents/DetalleFactura.vue')
    },      
    {
        path: '/detalle_cotizacion',
        name: 'detalleCotizacion',
        meta: { authRequired: true },
        component: () => import('./Details/RentDetail.vue')
    },
    {
        path: '/detalle_cotizacionLOP',
        name: 'detalleCotizacionLOP',
        meta: {authRequired: true},
        component: () => import('./Details/QuotationLOPDetail.vue')
    },
    {
        path: '/detalle_reserva',
        name: 'detalleReserva',
        meta: { authRequired: true },
        component: () => import('./Details/RentDetail.vue')
      },
];
